import React from 'react';
import AuthTokenContainer from '../containers/auth_token_container';

const AuthContext = React.createContext(new AuthTokenContainer());

export default AuthContext;
